import React from "react";
import { useNavigate } from "react-router-dom";
import { ArrowLeft } from "lucide-react";

export const BackLink = ({ label = "Back" }) => {
  const nav = useNavigate();
  return (
    <button
      data-testid="back-link"
      onClick={() => nav(-1)}
      className="text-sm text-neutral-500 hover:text-forest inline-flex items-center gap-1.5 mb-4 transition-colors"
    >
      <ArrowLeft className="w-4 h-4" /> {label}
    </button>
  );
};
